import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import {
  UserWorkoutsInterface,
  workOutCreateInterface,
  WorkoutDataInterface,
  WorkoutExerciseByIdInterface,
  workOutExerciseCreateInterface,
} from "../types/types";

export const workOuts = {
  // create
  createWorkOut: (body: workOutCreateInterface) => {
    return HttpClient.post<workOutCreateInterface>(
      API_ENDPOINTS.WORKOUTS,
      body
    );
  },
  createWorkOutExercise: (
    body: workOutExerciseCreateInterface[],
    id: number
  ) => {
    return HttpClient.post<workOutExerciseCreateInterface[]>(
      `${API_ENDPOINTS.WORKOUTS_EXERCISES}/${id}`,
      body
    );
  },
  // get
  GetWorkoutData: (options?: any) => {
    return HttpClient.get<WorkoutDataInterface>(
      API_ENDPOINTS.WORKOUTS,
      options
    );
  },
  GetWorkoutById: (id?: number) => {
    return HttpClient.get<WorkoutExerciseByIdInterface>(
      `${API_ENDPOINTS.WORKOUTS}/${id}`
    );
  },
  GetUserWorkoutData: (options?: any) => {
    return HttpClient.get<UserWorkoutsInterface>(
      API_ENDPOINTS.USER_WORKOUTS,
      options
    );
  },
  //  update
  UpdateWorkout: (body: workOutCreateInterface, id: number) => {
    return HttpClient.put<workOutCreateInterface>(
      `${API_ENDPOINTS.WORKOUTS}/${id}`,
      body
    );
  },

  UpdateWorkOutExercise: (
    body: workOutExerciseCreateInterface[],
    id: number
  ) => {
    return HttpClient.put<workOutExerciseCreateInterface[]>(
      `${API_ENDPOINTS.WORKOUTS_EXERCISES}/${id}`,
      body
    );
  },
  // delete
  deleteWorkout: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.WORKOUTS}/${id}`);
  },
  deleteWorkoutExercise: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.WORKOUTS_EXERCISES}/${id}`);
  },
};
